import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { SearchX } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Seo, tryRedirect } from '../lib/seo';
import { LogoLoader } from '../components/common/LogoLoader';

export const NotFoundPage = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    setChecking(true);
    tryRedirect(pathname, navigate).then((moved) => !moved && setChecking(false));
  }, [pathname, navigate]);

  if (checking) return <LogoLoader label="Loading..." className="min-h-[60vh]" />;
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 bg-alabaster" data-testid="not-found-page">
      <Seo title="Page not found | DrPortals" override={{ robots_index: false }} />
      <div className="text-center max-w-md">
        <SearchX className="w-14 h-14 text-gray-300 mx-auto mb-4" />
        <h1 className="font-heading text-3xl font-bold text-[#23265d] mb-3">Page not found</h1>
        <p className="text-gray-600 mb-8">The page you are looking for has moved or no longer exists.</p>
        <div className="flex flex-wrap gap-3 justify-center">
          <Link to="/"><Button className="bg-[#23265d] hover:bg-[#1e1e4b] rounded-full" data-testid="not-found-home-btn">Go to Home</Button></Link>
          <Link to="/doctors"><Button variant="outline" className="rounded-full" data-testid="not-found-doctors-btn">Find Doctors</Button></Link>
        </div>
      </div>
    </div>
  );
};
